// src/i18n.js

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Importar los JSON de traducción (carpeta locales)
import translationEN from './locales/en/translation.json';
import translationES from './locales/es/translation.json';
import translationMAYA from './locales/maya/translation.json';

// Inicializar i18next
i18n
  .use(initReactI18next) // conecta i18next con React
  .init({
    resources: {
      en: {
        translation: translationEN
      },
      es: {
        translation: translationES
      },
      maya: {
        translation: translationMAYA
      }
    },
    lng: 'es',                    // idioma inicial ("es" para español)
    fallbackLng: 'en',            // si no existe una clave en 'es', usar 'en'
    supportedLngs: ['es', 'en', 'maya'],
    interpolation: {
      escapeValue: false          // no escapar cadenas (React ya lo hace)
    }
  });

export default i18n;
